<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="testStepList"
        :sort-by="['stepNumber', 'substepNumber']"
        :sort-desc="[false, false]"
        disable-pagination
        hide-default-footer
        item-key="id"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td>
              <router-link :to="`/pack/${packId}/releaseNote/${releaseNoteId}/testStep/${item.id}/edit`"
                >{{ item.stepNumber }}{{ item.substepNumber ? `.${item.substepNumber}` : `` }}</router-link
              >
            </td>
            <td><span v-html="item.scenario"></span></td>
            <td><span v-html="item.expectedOutcome"></span></td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "testStepTableTwo",
  computed: {
    releaseNote() {
      return this.$store.state.releaseNote.releaseNoteRecord;
    },
    releaseNoteId() {
      return parseInt(this.$route.params.releaseNoteId, 10);
    },
    testStepList() {
      return this.$store.getters["testStep/testStepList"](this.releaseNoteId);
    },
  },
  async created() {
    try {
      await this.getTestStepList(this.releaseNoteId);
    } catch (e) {
      console.error(e);
      this.$notifyError("Error loading test steps");
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Step",
          align: "left",
          sortable: false,
          value: "stepNumber",
        },
        {
          text: "Scenario",
          align: "left",
          sortable: false,
          value: "scenario",
        },
        {
          text: "Expected Outcome",
          align: "left",
          sortable: false,
          value: "expectedOutcome",
        },
      ],
    };
  },
  methods: {
    async getTestStepList(releaseNoteId, serviceArea) {
      await this.$store.dispatch("testStep/list", {
        releaseNoteId,
        serviceArea,
      });
    },
  },
  props: ["packId"],
  watch: {
    releaseNoteId(val) {
      this.getTestStepList(val);
    },
  },
};
</script>
